import Vue from 'vue';
import modules from '@telexpress/modules';
import '@telexpress/modules/dist/modules.css';

Vue.use(modules);
